<template>
  <div>
    <div :class="{ 'toolbox-button': true, 'toolbox-button-selected': value }" @click="handleClick" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <icon :icon="['fal', (value ? 'check-' : '') + 'circle']"/>
      <slot/>
    </div>
  </div>
</template>

<script>
import SimpleButton from "../button/SimpleButton";
import SimpleLayout from "../layout/SimpleLayout";

export default {
  name: "ToolboxToggleButton",
  components: {SimpleLayout, SimpleButton},
  data: function () {
    return {}
  },
  props: {
    helpText: String,
    value: Boolean
  },
  inject: {
    showHelp: 'showHelp',
    clearHelp: 'clearHelp'
  },
  methods: {
    async handleClick() {
      this.$emit('input', !this.value)
      },
    blurConfirmationMessage(e) {
      if (e.target.parents(this.$refs.confirmButton.$el)) {
        return;
      }
      this.showProtectedMessage = false;
      window.removeEventListener("mousedown", this.blurConfirmationMessage);
    },
    async sendPressEvent() {
      if (this.showProtectedMessage) {
        window.removeEventListener("mousedown", this.blurConfirmationMessage);
      }
      this.showProtectedMessage = false;
      return await this.$listeners.press();
    },
    handleMouseEnter() {
      this.showHelp(this.helpText);
    },
    handleMouseLeave() {
      this.clearHelp();
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global";

.toolbox-button {
  &-selected {
    background-color: mix($openRed, $backgroundColor, 70);
  }
  width: min-content;
  height: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  gap: 5px;
  align-items: center;
  background-color: lighten(#262C32, 17);
  border: 1px solid lighten(#262C32, 17);
  padding: 0px 5px 0px 5px;
  border-radius: 5px;
  white-space: nowrap;
}

.toolbox-button:hover {
  cursor: pointer;
  background-color: lighten(#262C32, 5);
  border: 1px solid lighten(#262C32, 5);
}
</style>